/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type OnboardingStatusResult = {
  /**
   * Whether the organization has at least one verified domain in WorkOS. Single sign-on cannot be set up until one is verified.
   */
  domainVerified: boolean;
  /**
   * Whether the organization has at least one linked directory sync in WorkOS.
   */
  dsyncConfigured: boolean;
  /**
   * Whether the organization has at least one active SSO connection in WorkOS.
   */
  ssoConfigured: boolean;
  /**
   * Domains WorkOS has verified for the organization. Single sign-on only works for users on these domains.
   */
  verifiedDomains: Array<string>;
};

/** @internal */
export const OnboardingStatusResult$inboundSchema: z.ZodMiniType<
  OnboardingStatusResult,
  unknown
> = z.pipe(
  z.object({
    domain_verified: z.boolean(),
    dsync_configured: z.boolean(),
    sso_configured: z.boolean(),
    verified_domains: z.array(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "domain_verified": "domainVerified",
      "dsync_configured": "dsyncConfigured",
      "sso_configured": "ssoConfigured",
      "verified_domains": "verifiedDomains",
    });
  }),
);

export function onboardingStatusResultFromJSON(
  jsonString: string,
): SafeParseResult<OnboardingStatusResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OnboardingStatusResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OnboardingStatusResult' from JSON`,
  );
}
